import { useState } from "react";
import { PageHeader } from "@/components/StatCard";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SummaryTab } from "@/components/accounting/SummaryTab";
import { JournalTab } from "@/components/accounting/JournalTab";
import { LedgerTab } from "@/components/accounting/LedgerTab";
import { BalanceSheetTab } from "@/components/accounting/BalanceSheetTab";
import { IncomeStatementTab } from "@/components/accounting/IncomeStatementTab";
import { AccountsTab } from "@/components/accounting/AccountsTab";
import { ExpensesTab } from "@/components/accounting/ExpensesTab";
import { IncomesTab } from "@/components/accounting/IncomesTab";
import { PeriodsTab } from "@/components/accounting/PeriodsTab";

const TABS = [
  ["summary", "Ringkasan", SummaryTab], ["journal", "Jurnal Umum", JournalTab], ["incomes", "Pendapatan", IncomesTab], ["expenses", "Pengeluaran", ExpensesTab], ["ledger", "Buku Besar", LedgerTab],
  ["balance", "Neraca", BalanceSheetTab], ["income", "Laba Rugi", IncomeStatementTab], ["periods", "Tutup Buku", PeriodsTab], ["coa", "Chart of Accounts", AccountsTab],
];

export default function Accounting() {
  const [tab, setTab] = useState("summary");
  const Active = TABS.find((t) => t[0] === tab)[2];
  return (
    <div data-testid="accounting-page">
      <PageHeader title="Akuntansi" subtitle="Pembukuan double-entry: jurnal umum, buku besar, neraca, dan laba rugi (khusus admin)" />
      <Tabs value={tab} onValueChange={setTab} className="mb-4 rise rise-1">
        <TabsList className="bg-sky-50 flex-wrap h-auto">{TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`tab-acc-${v}`}>{l}</TabsTrigger>)}</TabsList>
      </Tabs>
      <Active />
    </div>
  );
}
